<template>
    <div>
        <b-table hover :items="items" :fields="fields" show-empty ref="uploadTable">

            <template v-slot:empty="scope">
                <div class="drop-zone w-100 p-5" @drop.prevent="dropFile" @dragover.prevent>
                    <div class="h5 font-weight-bolder text-center">Drop files anywhere to upload</div>
                    <div class="h5 font-weight-bolder text-center">or</div>
                    <upload-button :folder_id="folder_id" class="text-center" @onUploaded="addDocument"></upload-button>
                </div>
            </template>

            <template v-slot:cell(preview)="data">
                <div v-if="data.item.document">
                    <document-preview
                            v-if="data.item.document"
                            :document="data.item.document"
                            :cache="false"
                            :width="100"
                    ></document-preview>
<!--                    <img v-if="isImage(data.item.document)" :src="data.item.document.getFileUrl" width="40" height="auto" @click="showPreview(data.item.document)" class="document-thumb" />-->
<!--                    <span v-else><b-button variant="sf" squared @click="showPreview(data.item.document)"><i class="fal fa-eye"></i></b-button></span>-->
                </div>
            </template>

            <template v-slot:cell(actions)="data">
                <upload-button
                    :folder_id="folder_id"
                    :manage_meta="manage_meta"
                    :manage_attachments="manage_attachments"
                    :manage_permissions="manage_permissions"
                    :manage_cover="manage_cover"
                    :attachment_models="attachment_models"
                    :permission_models="permission_models"
                    :pre_loaded_file="data.item.file"
                    :pre_loaded_document="data.item.document"
                    :editable="true"
                    @onUploaded="(document) => updateRow(data.item, data.index, document)"
                    @onDocumentChange="(document) => updateRow(data.item, data.index, document)"
                    @onDelete="(document) => deleteRow(data.item, data.index, document)"
                >
                </upload-button>
            </template>

        </b-table>

<!--        <c-modal :show.sync="show_preview" title="Preview" size="lg">-->
<!--            <img v-if="preview_type === 'image'" ref="upload_preview_image" width="100%">-->
<!--            <iframe v-if="preview_type === 'file'" ref="upload_preview_iframe" width="100%"></iframe>-->
<!--            <template #footer=""><span></span></template>-->
<!--        </c-modal>-->

        <upload-button v-if="!disable_upload" :folder_id="folder_id" ref="footer_upload" @onUploaded="addDocument" :class="[(items.length === 0 ? 'd-none' : '')]"></upload-button>
    </div>
</template>

<script>
  import ToastNotifications from "../shared/mixins/ToastNotifications";
  import UploadButton from "./UploadButton";
  import image_mime_types from "./image_mime_types";
  import Document from "../../models/Document";
  import DocumentPreview from "./DocumentPreview";

  export default {
    name: 'UploadTable',
    components: {DocumentPreview, UploadButton},
    mixins: [ToastNotifications],
    props: {
      documents: {
        default: function () {
          return null;
        }
      },
      folder_id: {
        default: function () {
          return null;
        }
      },
      manage_meta: {
        default: function () {
          return false;
        }
      },
      manage_attachments: {
        default: function () {
          return false;
        }
      },
      manage_permissions: {
        default: function () {
          return false;
        }
      },
      manage_cover: {
        default: function () {
          return false;
        }
      },
      attachment_models: {
        default: function () {
          return null;
        }
      },
      permission_models: {
        default: function () {
          return null;
        }
      },
      show_header: {
        default: function () {
          return true;
        }
      },
      hidden_fields: {
        default: function () {
          return null;
        }
      },
      disable_upload: {
        default: function () {
          return false;
        }
      },
    },
    data() {
      return {
        items: [],
        fields: [
          {key: 'preview', label: 'Preview'},
          {key: 'name', label: 'Name'},
          {key: 'size', label: 'Size'},
          {key: 'description', label: 'Description'},
          {key: 'actions', label: 'Actions'},
        ],
        show_preview: false,
        preview_type: null
      };
    },
    methods: {
      dropFile(e) {
        let droppedFiles = e.dataTransfer.files;
        if(!droppedFiles) return;
        ([...droppedFiles]).forEach(f => {
          this.items.push({
            file: f,
            document: null,
            name: null,
            size: null,
            description: null,
          });
        });
      },
      addDocument(document) {
        this.items.push({
          file: null,
          document: document,
          name: document.name,
          size: document.size,
          description: document.description,
        });
        if(this.$refs.footer_upload) {
          this.$refs.footer_upload.resetUpload();
        }
      },
      updateRow(item, key, document) {
        // if((item.document ? item.document.id : null) === (document ? document.id : null)) {
        //   return false;
        // }
          item = {
            file: null,
            document: document,
            name: document.name,
            size: document.size,
            description: document.description,
          };
          this.items.splice(key, 1, item);
          this.$emit('change', this.items.map(item => item.document));
      },
      deleteRow(item, key, document) {
        this.items.splice(key, 1);
      },
      isImage(document) {
        let is_image = false;
        image_mime_types.forEach((mime_type) => {
          if(mime_type.Template === document.mime_type) {
            is_image = true;
          }
        });
        return is_image;
      },
      showPreview(document) {
        if(this.isImage(document)) {
          this.preview_type = 'image';
          this.$refs.upload_preview_image.src = document.getFileUrl;
          this.show_preview = true;
        } else {
          this.preview_type = 'file';
          this.show_preview = true;
          Document.api().file(document.id).then((response) => {
            let data = response.response.data;
            let type = document.mime_type;
            let file = new Blob([data], {type: type});
            this.$refs.upload_preview_iframe.src = window.URL.createObjectURL(file);
          });
        }
      }
    },
    created() {
      if(this.documents) {
        this.documents.forEach((document) => {
          this.addDocument(document);
        });
      }
      if(this.hidden_fields) {
        this.fields.forEach((field, index) => {
          if(this.hidden_fields.includes(field.key)) {
            this.fields.splice(index, 1);
          }
        });
      }
      if(!this.show_header) {
        this.fields.forEach((field) => {
          field.thClass = 'd-none';
        });
      }
    }
  }
</script>
<style>
    .drop-zone:hover {
        background-color: rgba(0,0,0,0.1);
    }
</style>